import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { ref, onMounted, reactive } from 'vue'
import useModal from '@/composables/useModal'
import i18n from '@/i18n/i18n'

export default async function () {
  const formStore = useFormStore()
  const { requestNumber = '' } = formStore.draft

  const dialogProps = reactive({
    title: i18n.global.t('confirmation'),
    label: i18n.global.t('confirmationMsgFoVisaServiceDetailsMSG1')
  })
  try {
    const res = await apiHelperService.get(
      `/api/individual/visa/draft/requestNumber/${requestNumber}/validate`
    )
    if (res.isValid) {
      const { confirm } = useModal(dialogProps)
      await confirm()
      return true
    }
  } catch (error) {
    console.error('Error submitting application: user995PreReview', error)
  }
}
